import { Routes } from "@angular/router";
import { ImagesListComponent } from "./images-list/images-list.component";
import { ImagesCrateComponent } from "./images-crate/images-crate.component";
import { UploadImageComponent } from "./upload-image/upload-image.component";
import { ImagesDetailsComponent } from "./images-details/images-details.component";
import { ImagesEditComponent } from "./images-edit/images-edit.component";
import { ImageDeleteComponent } from "./image-delete/image-delete.component";

export const imagesRoutes: Routes = [
  { path: '', redirectTo: 'list', pathMatch: 'full' },
  { path: 'list', component: ImagesListComponent },
  { path: 'create', component: ImagesCrateComponent },
  // { path: 'upload', component: UploadImageComponent },
  { path: 'details/:id', component: ImagesDetailsComponent },
  { path: 'edit/:id', component: ImagesEditComponent },
  { path: 'delete/:id', component: ImageDeleteComponent },
]
